import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { JSONRpcResponse } from '../../Interfaces/JSONRpcResponse'
import { JSONRpc } from '../service-jsonrpc'

@Injectable({
    providedIn: "root",
})
export class DossierService {
    constructor(private http: HttpClient) { }
    getListToSave(ids: any, options: any[] = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: '2.0',
            method: 'webservice.dossier:getListToSave',
            params: {
                ids: ids,
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }
    setDossier(options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: "2.0",
            method: "webservice.dossier:setDossier",
            params: {
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }
    get(id: any, options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: "2.0",
            method: "webservice.dossier:get",
            params: {
                id: id,
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }
    getList(options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: "2.0",
            method: "webservice.dossier:getList",
            params: {
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }
    getformulairelist(id: string, options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: "2.0",
            method: "webservice.dossier:getformulairelist",
            params: {
                id: id,
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }
    getDocumentList(id: string, options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: "2.0",
            method: "webservice.dossier:getDocumentList",
            params: {
                id: id,
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }
    getTiersDossier(tiers_id: any, options: any = []): Observable<JSONRpcResponse> {

        let rpcMethod = new JSONRpc({
            jsonrpc: "2.0",
            method: "webservice.dossier:getTiersDossier",
            params: {
                tiers_id: tiers_id,
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)

    }
    getinstructionlist(id: string, options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: "2.0",
            method: "webservice.dossier:getinstructionlist",
            params: {
                id: id,
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }

    getCourrierList(id: string, options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: "2.0",
            method: "webservice.dossier:getCourrierList",
            params: {
                id: id,
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }
    
    getStatistiqueList(id: string, options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: "2.0",
            method: "webservice.dossier:statistique",
            params: {
                id: id,
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }
	
	getStatistiqueDossierList(ids: any = [], options: any = []): Observable<JSONRpcResponse> {
	        let rpcMethod = new JSONRpc({
	            jsonrpc: "2.0",
	            method: "webservice.dossier:statistiques",
	            params: {
	                ids: ids,
	                options: options,
	            },
	        })
			return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
	getVisiteList(ids: any = [], options: any = []): Observable<JSONRpcResponse> {
		        let rpcMethod = new JSONRpc({
		            jsonrpc: "2.0",
		            method: "webservice.dossier:visites",
		            params: {
		                ids: ids,
		                options: options,
		            },
		        })
				return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
	getFormulaireHTMLList(ids: any = [], options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: "2.0",
            method: "webservice.dossier:formulaireshtml",
            params: {
                ids: ids,
                options: options,
            },
        })
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
    
	
	archive(id: string, state:number = 1, options: any = []): Observable<JSONRpcResponse> {
	        let rpcMethod = new JSONRpc({
	            jsonrpc: "2.0",
	            method: "webservice.dossier:archive",
	            params: {
	                id: id,
					state: state,
	                options: options,
	            },
	        })
			return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
	search(paramtype:any,id: any,typeid:any='ENFANT', options: any = []): Observable<JSONRpcResponse> {
	       let rpcMethod = new JSONRpc({
	           jsonrpc: "2.0",
	           method: "webservice.dossier:search",
	           params: {
				   typeid:typeid,
				   paramtype: paramtype,
				   
	               id: id,
	               options: options,
	           },
	       })
	       return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
}
